export default {
    find_offers_by: 'Find services by',
}
